import {
	Analytics,
	BlogFormPage,
	BlogPage,
	Breeds,
	Contacts,
	Dashboard,
	FAQPage,
	HouseholdSafety,
	PetFormPage,
	Pets,
	Profile,
	Resources,
	Settings,
	Training,
	UserFormPage,
	Users
} from '@/pages';
import { Navigate, Route, Routes } from 'react-router-dom';

import RoleProtectedRoute from '../auth/role-protected-route';
import { ROUTES } from '@/constants';

const AdminRoutes = () => {
	return (
		<Routes>
			<Route
				path='dashboard'
				element={
					<RoleProtectedRoute>
						<Dashboard />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path='analytics'
				element={
					<RoleProtectedRoute>
						<Analytics />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path='users'
				element={
					<RoleProtectedRoute requiredRole='super_admin'>
						<Users />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path='users/create'
				element={
					<RoleProtectedRoute requiredRole='super_admin'>
						<UserFormPage />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path='users/edit/:id'
				element={
					<RoleProtectedRoute requiredRole='super_admin'>
						<UserFormPage />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path='pets'
				element={
					<RoleProtectedRoute>
						<Pets />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path='pets/create'
				element={
					<RoleProtectedRoute>
						<PetFormPage />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path='pets/edit/:id'
				element={
					<RoleProtectedRoute>
						<PetFormPage />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path='settings'
				element={
					<RoleProtectedRoute requiredRole='super_admin'>
						<Settings />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path='profile'
				element={
					<RoleProtectedRoute>
						<Profile />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path='contacts'
				element={
					<RoleProtectedRoute>
						<Contacts />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path='admin/resources'
				element={
					<RoleProtectedRoute>
						<Resources />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path='admin/training'
				element={
					<RoleProtectedRoute>
						<Training />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path='admin/household-safety'
				element={
					<RoleProtectedRoute>
						<HouseholdSafety />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path='admin/breeds'
				element={
					<RoleProtectedRoute>
						<Breeds />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path='admin/blog'
				element={
					<RoleProtectedRoute>
						<BlogPage />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path='admin/blog/create'
				element={
					<RoleProtectedRoute>
						<BlogFormPage />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path='admin/blog/edit/:id'
				element={
					<RoleProtectedRoute>
						<BlogFormPage />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path='admin/faq'
				element={
					<RoleProtectedRoute>
						<FAQPage />
					</RoleProtectedRoute>
				}
			/>
			<Route
				path=''
				element={<Navigate to={ROUTES.DASHBOARD} replace />}
			/>
			<Route path='*' element={<Navigate to={ROUTES.DASHBOARD} replace />} />
		</Routes>
	);
};

export { AdminRoutes };
export default AdminRoutes;
